// extracted by mini-css-extract-plugin
export default {"mainContainer":"energyTab_mainContainer__P-lrP","imageStyle":"energyTab_imageStyle__Tor4P","listStyle":"energyTab_listStyle__WIpSF","buttonStyle":"energyTab_buttonStyle__pR2P3"};